import { useState, useEffect, useMemo } from 'react';
import './Infrastructure.css';
import Infrastructure from './Infrastructure';
import 'react-toastify/dist/ReactToastify.css';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";

const InfrastructureRisk = ({ refreshToken,handleWizardChanged, handleWizardChangedBack, handleMoveToNextPage }) => {
    const [infrastructure, setInfrastructure] = useState({
        Section: 'InfrastructureRisk', SectionName: 'Infrastructure', IsMapOnly: false, IsMapRisk: false
    });
    useEffect(() => {
         OnPageload();
    }, [])
    const OnPageload = async (e) => {

    }
    return (
        <div>
            <Infrastructure refreshToken={refreshToken} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} handleMoveToNextPage={handleMoveToNextPage} pageSection={infrastructure} ></Infrastructure>
        </div>
    )
}
export default InfrastructureRisk;